export function Avatar({ src, alt, fallback, size = "md", className = "" }) {
  const sizeClasses = {
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-12 w-12 text-base",
    xl: "h-16 w-16 text-lg",
  }

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`rounded-full object-cover ${sizeClasses[size]} ${className}`}
      />
    )
  }

  return (
    <div
      className={`
        flex items-center justify-center rounded-full bg-primary/10 text-primary font-medium
        ${sizeClasses[size]} ${className}
      `}
    >
      {fallback || alt?.charAt(0)?.toUpperCase() || "?"}
    </div>
  )
}
